var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=32px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 8.00008V2.66675",
    stroke: "#1E1E20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.6665 29.3334H29.3332",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.6665 16.0001H29.3332",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20 16.0001L20 29.3334",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 16.0001L12 29.3334",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M23.2 16.0001C23.6418 16.0001 24.0042 15.6409 23.9606 15.2012C23.5598 11.158 20.1487 8.00006 16 8.00006C11.8513 8.00006 8.44024 11.158 8.03939 15.2012C7.9958 15.6409 8.35817 16.0001 8.8 16.0001H23.2Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 5.3335,
    y: 16.0001,
    width: 21.3333,
    height: 13.3333,
    rx: 1.33333,
    stroke: "#1E1E20",
    strokeWidth: 2.66667
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 6",
    d: "M16 2.66669H19.3333C19.7015 2.66669 20 2.96516 20 3.33335V4.66669C20 5.03488 19.7015 5.33335 19.3333 5.33335H16V2.66669Z",
    stroke: "#1E1E20",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentIcon);
export default __webpack_public_path__ + "static/media/governmentIcon.069e905aad4afb42b87ce20a270c582e.svg";
export { ForwardRef as ReactComponent };